import styled from "styled-components"
import { GIVONIC } from "@styles/fonts"
import { DARK_VIOLET } from "@styles/colors"

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-height: 24px;
  overflow: hidden;
`

export const BalanceContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

interface BalanceTextProps {
  $showBalance: boolean;
}

export const BalanceText = styled.p<BalanceTextProps>`
  font-size: ${({ $showBalance }) => $showBalance ? '24px' : '30px'};
  font-family: ${GIVONIC.black};
  position: relative;
  color: ${DARK_VIOLET};
  top: ${({ $showBalance }) => $showBalance ? '3px' : '8px'};
`

export const EyeContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`
